import { Component } from '@theme/component';
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

/** @extends {Component<{cards: HTMLElement}>} */
class BlossyRecentlyViewed extends Component {
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#load(this.#controller.signal);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }

  /** @param {AbortSignal} signal */
  async #load(signal) {
    try {
      const stored = RecentlyViewed.getProducts();
      if (!Array.isArray(stored) || !this.dataset.sectionId || !this.dataset.currentProduct) return;
      const ids = [...new Set(stored.map(String))]
        .filter((id) => /^\d+$/.test(id) && id !== this.dataset.currentProduct)
        .slice(0, 4);
      if (!ids.length) return;

      const url = new URL(this.dataset.searchUrl || '/search', location.origin);
      url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
      url.searchParams.set('type', 'product');
      const html = await sectionRenderer.getSectionHTML(this.dataset.sectionId, false, url, signal);
      if (signal.aborted || !this.isConnected) return;

      const response = new DOMParser().parseFromString(html, 'text/html');
      const found = new Map([...response.querySelectorAll('[data-recent-product]')]
        .map((card) => [card.getAttribute('data-recent-product'), card]));
      const cards = ids.map((id) => found.get(id)).filter(Boolean);
      if (!cards.length || !this.refs.cards) return;
      this.refs.cards.replaceChildren(...cards);
      this.hidden = false;
    } catch {
      // Storage restrictions, missing products and request failures leave history hidden.
    }
  }
}

if (!customElements.get('blossy-recently-viewed')) {
  customElements.define('blossy-recently-viewed', BlossyRecentlyViewed);
}
